import { Typography, useTheme } from "@mui/material";
import RestrictedModalIllustration from "assets/illustrations/restrictedModalIllustration.svg";
import { ModalContentWrapper } from "components/primitives/ModalContentWrapper";
import { ModalTitle } from "components/primitives/ModalTitle";
import { useAppSelector } from "hooks/utilsHooks/storeHooks";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { selectShortFridgeId } from "slices/fridgeInfoSlice";
import { logToSentry } from "utils/logger";
import { BasicModal } from "./BasicModal";
import { ModalSupportFooter } from "./ModalSupportFooter";

const RestrictedModalContent = () => {
	const fridgeId = useAppSelector(selectShortFridgeId);
	const { t } = useTranslation();
	const theme = useTheme();

	useEffect(() => {
		logToSentry(`Restricted modal displayed on fridge: ${fridgeId}`, "info");
	}, [fridgeId]);

	return (
		<ModalContentWrapper>
			<ModalTitle variant="promoHeader">{t("modals.restricted.title")}</ModalTitle>
			<Typography variant="promoText" sx={{ marginRight: "auto", marginBottom: 10 }}>
				{t("modals.restricted.description")}
			</Typography>
			<RestrictedModalIllustration />
			<ModalSupportFooter fridgeId={fridgeId} background={theme.palette.copper.main} />
		</ModalContentWrapper>
	);
};

export const RestrictedModal = () => (
	<BasicModal modalContent={<RestrictedModalContent />} open={true} closable={false} fullHeight={true} />
);
